function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, computed } from "vue";
import { caseAuthTypeList } from "@/common/demand";
import { updateCase } from "@/api/material/case";
export default defineComponent({
    props: {
        btnText: {
            type: String,
            default: "\u4FEE\u6539"
        },
        id: {
            type: Number,
            default: 0
        },
        model: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    components: {},
    setup: function setup(props, param) {
        var emit = param.emit;
        var dialogVisible = ref(false);
        var loading = ref(false);
        var fromModel = ref({
            price: 0,
            auth_type: 0,
            description: ""
        });
        var formConfig = computed(function() {
            return {
                inline: false,
                labelPosition: "right",
                labelWidth: "120px"
            };
        });
        var fromSchema = computed(function() {
            return {
                type: "object",
                properties: {
                    price: {
                        component: "input-number",
                        title: "\u53C2\u8003\u552E\u4EF7",
                        rules: [
                            {
                                required: true,
                                message: "\u53C2\u8003\u552E\u4EF7\u4E0D\u80FD\u4E3A\u7A7A",
                                trigger: "blur"
                            }, 
                        ],
                        field: {
                            placeholder: "",
                            "controls-position": "right",
                            min: 0,
                            style: {
                                width: "250px"
                            }
                        }
                    },
                    auth_type: {
                        component: "select",
                        title: "\u7D20\u6750\u6388\u6743\u7EF4\u5EA6",
                        field: {
                            style: {
                                width: "250px"
                            },
                            options: caseAuthTypeList
                        }
                    },
                    description: {
                        component: "input",
                        title: "\u8BF4\u660E",
                        prop: "description",
                        field: {
                            type: "textarea",
                            placeholder: "",
                            style: {
                                width: "450px"
                            },
                            maxlength: 30,
                            "show-word-limit": true
                        }
                    }
                }
            };
        });
        var handleClick = function() {
            fromModel.value = {
                price: props.model.price,
                auth_type: props.model.auth_type,
                description: props.model.description
            };
            dialogVisible.value = true;
        };
        var handleClose = function() {
            if (!loading.value) {
                dialogVisible.value = false;
            }
        };
        var handleChange = function() {};
        var handleSubmit = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            loading.value = true;
                            _ctx.next = 4;
                            return updateCase(_objectSpreadProps(_objectSpread({}, fromModel.value), {
                                id: props.id
                            }));
                        case 4:
                            loading.value = false;
                            handleClose();
                            emit("refresh");
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }));
            return function handleSubmit() {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            loading: loading,
            dialogVisible: dialogVisible,
            formConfig: formConfig,
            fromSchema: fromSchema,
            fromModel: fromModel,
            handleClick: handleClick,
            handleClose: handleClose,
            handleChange: handleChange,
            handleSubmit: handleSubmit
        };
    }
});
